import { getRequest } from 'utils/api/apiRequest'
import { WithPagination } from 'utils/api/pagination'
import { SocialWallPost } from 'utils/api/SocialWall/types'

export type GetSocialWallPostsResponse = WithPagination<SocialWallPost>

export const getSocialWallPosts = ({ pageParam = 1, params = {} }) =>
  getRequest<GetSocialWallPostsResponse>(`/social-wall/posts`, { params: { page: pageParam, ...params } })
